import { useQuery } from '@tanstack/react-query';
import qs from 'query-string';

import CategoryApi from '../../../lib/api/category/CategoryApi';
import { CATEGORY } from '../../../constants/queryKeys';

/**
 * 카테고리 리스트 엑셀 다운로드 응답 데이터 타입
 * @typedef categoryExcelDownloadResponseDataType
 * @property {string} adminEmail - 다운로드 한 카테고리 엑셀 리스트 파일을 받을 이메일
 */

/**
 * 검색한 카테고리 리스트 엑셀 다운로드를 요청하는 query hook
 * @param {object} filterOption -  카테고리 검색 필터
 * @param {number} [filterOption.id] - 카테고리 고유 id
 * @param {string} [filterOption.name] - 카테고리 명
 * @param {number} [filterOption.type] - 카테고리 종류
 * @param {number} [filterOption.status] - 카테고리 상태
 * @param {number} [filterOption.isExhibit] - 카테고리 전시여부
 * @param {number} [filterOption.exposureType] - 카테고리 노출타입
 * @param {number} [filterOption.sortType] - 카테고리 정렬타입
 * @param {number} [filterOption.degree] - 카테고리 차수
 * @param options - react-query options 객체
 * @return {UseQueryResult<AxiosPromise<categoryExcelDownloadResponseType>, AxiosError>}
 */
const useCategoryExcelDownload = (filterOption, options) => {
  const queryString = `?${qs.stringify(filterOption, { skipNull: true })}`;

  return useQuery(
    [...CATEGORY.LIST_EXCEL, queryString],
    () => CategoryApi.getCategoryExcelDownload(queryString),
    options,
  );
};

export default useCategoryExcelDownload;
